module.exports = __webpack_public_path__ + "static/media/search.6f5bf574.svg";